import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import apiClient from '../api/apiClient';
import './LoginPage.css';

const LoginPage = () => {
  // Input felter
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [view, setView] = useState('login'); // 'login', 'select_context', 'forgot'
  const [contexts, setContexts] = useState([]); // Listen over skoler man kan vælge
  // -------------------------------------------

  // Feedback beskeder
  const [message, setMessage] = useState(null);
  const [localError, setLocalError] = useState(null);

  const { login, error: authError } = useAuth();
  const navigate = useNavigate();

  // Helper til at gøre rolle-navne pæne
  const formatRole = (r) => {
    if (r === 'SC_ADMIN') return 'Administrator';
    if (r === 'TEACHER' || r === 'CENSOR') return 'Underviser / Censor';
    if (r === 'ADMIN') return 'System Administrator';
    return r;
  };

  // TRIN 1: Forsøg login (Tjekker om der er flere skoler)
  const handleLogin = async (e) => {
    e.preventDefault();
    setLocalError(null);
    setMessage(null);
    
    // Kald login (uden accessId først)
    const result = await login(email, password);

    if (result?.requiresSelection) {
      // Hvis backend siger vi skal vælge skole: Gem listen og skift view
      setContexts(result.contexts);
      setView('select_context');
    } else if (result?.success) {
      // Hvis direkte login (kun 1 skole): Gå til dashboard
      navigate('/dashboard');
    }
  };

  // TRIN 2: Vælg skole (Context Switching)
  const handleSelectContext = async (accessId) => {
    // Kald login igen, men NU med accessId
    const result = await login(email, password, accessId);
    if (result?.success) {
      navigate('/dashboard');
    }
  };

  // Glemt Kodeord funktion
  const handleForgot = async (e) => {
    e.preventDefault();
    setMessage(null);
    setLocalError(null);
    try {
      const res = await apiClient.post('/api/auth/forgot-password', { email });
      setMessage(res.data.message);
    } catch(err) { 
      setLocalError('Der skete en fejl. Prøv igen senere.'); 
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        
        {/* DYNAMISK TITEL */}
        <h1 className="login-title">
          {view === 'select_context' ? 'Vælg Profil' : (view === 'forgot' ? 'Nulstil Kode' : 'SC-Admin')}
        </h1>
        
        {/* DYNAMISK SUBTITLE */}
        <p className="login-subtitle">
          {view === 'select_context' ? 'Du har adgang til flere funktioner. Vælg hvor du vil logge ind:' : 
           (view === 'forgot' ? 'Indtast din email for at modtage et link' : 'Log ind for at administrere prøver')}
        </p>

        {/* FEEDBACK BESKEDER */}
        {(authError || localError) && (
          <div style={{background: '#d32f2f', color: 'white', padding: '10px', borderRadius: '4px', marginBottom: '1rem', fontSize: '0.9rem'}}>
            {authError || localError}
          </div>
        )}
        {message && (
          <div style={{background: '#2e7d32', color: 'white', padding: '10px', borderRadius: '4px', marginBottom: '1rem', fontSize: '0.9rem'}}>
            {message}
          </div>
        )}

        {/* --- VIEW 1: LOGIN FORM --- */}
        {view === 'login' && (
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input type="email" className="form-input" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="form-group">
              <label className="form-label">Adgangskode</label>
              <input type="password" className="form-input" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            <button type="submit" className="login-btn">Log Ind</button>
            <div style={{marginTop: '15px', fontSize: '0.9rem'}}>
              <span onClick={() => { setView('forgot'); setMessage(null); setLocalError(null); }} style={{color: '#003366', cursor: 'pointer', textDecoration: 'underline'}}>Glemt adgangskode?</span>
            </div>
          </form>
        )}

        {/* --- VIEW 2: CONTEXT SELECTOR (Vælg Skole) --- */}
        {view === 'select_context' && (
          <div className="context-list">
            {contexts.map(ctx => (
              <button 
                key={ctx.accessId} 
                className="context-btn"
                onClick={() => handleSelectContext(ctx.accessId)}
              >
                <div style={{fontWeight: 'bold', fontSize: '1rem'}}>{ctx.schoolName}</div>
                <div style={{fontSize: '0.85rem', opacity: 0.8}}>{formatRole(ctx.rettighed || ctx.role)}</div>
              </button>
            ))}
            
            <div style={{marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '15px'}}>
              <span onClick={() => { setView('login'); setPassword(''); setLocalError(null); }} style={{color: '#666', cursor: 'pointer'}}>
                &larr; Log ind som en anden
              </span>
            </div>
          </div>
        )}

        {/* --- VIEW 3: GLEMT KODE --- */}
        {view === 'forgot' && (
          <form onSubmit={handleForgot}>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input type="email" className="form-input" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <button type="submit" className="login-btn">Send Link</button>
            <div style={{marginTop: '15px', fontSize: '0.9rem'}}>
              <span onClick={() => { setView('login'); setMessage(null); setLocalError(null); }} style={{color: '#666', cursor: 'pointer'}}>&larr; Tilbage til login</span>
            </div>
          </form>
        )}

      </div>
    </div>
  );
};

export default LoginPage;